import React from "react";
import { Col, Row } from "antd";
import Container from "@/components/container/Container";
import ButtonComponent from "@/components/button/Button";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { getIsLoggedIn } from "@/reducers/commonSlice";

import "@/styles/components/footer-topbar.scss";

const FooterTopbar = () => {
  const isLoggedIn = useSelector(getIsLoggedIn);
  return (
    <div className="footer-container">
      <Container>
        <Row
          gutter={[
            { xs: 10, sm: 10, md: 15, lg: 20, xl: 70 },
            { xs: 10, sm: 10, md: 15, lg: 20, xl: 70 },
          ]}
        >
          <Col xs={24} sm={24} md={24} lg={8} xl={8} xxl={8}>
            <div className="logo" style={{ height: "30px", marginBottom: "10px" }}>
              <img src="/assets/images/logo.png" alt="logo" height="100%" />
            </div>
            <div className="content">
              At Inforens, we help students achieve their study abroad dreams with expert guidance.
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={8} xxl={8}>
            <div className="menus">
              <Row
                gutter={[
                  { xs: 13, sm: 13, md: 13, lg: 20, xl: 52 },
                  { xs: 13, sm: 13, md: 13, lg: 20, xl: 52 },
                ]}
              >
                <Col xs={12} sm={12} md={8} lg={7} xl={8} xxl={8}>
                  <div className="quick-links">
                    <div className="heading body-b2">Quick Links</div>
                    <div className="links">
                      <ButtonComponent varient="link">
                        <Link to="/">Home</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/guides">Mentors</Link>
                      </ButtonComponent>
                      {isLoggedIn && (
                        <ButtonComponent varient="link">
                          <Link to="/sessions">Sessions</Link>
                        </ButtonComponent>
                      )}
                      <ButtonComponent varient="link">
                        <Link to="/plans">Plans</Link>
                      </ButtonComponent>
                      {isLoggedIn && (
                        <ButtonComponent varient="link">
                          <Link to="/dashboard">Dashboard</Link>
                        </ButtonComponent>
                      )}
                      <ButtonComponent varient="link">
                        <Link to="/blogs">Blogs</Link>
                      </ButtonComponent>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={8} lg={7} xl={8} xxl={8}>
                  <div className="help">
                    <div className="heading body-b2">Help</div>
                    <div className="links">
                      <ButtonComponent varient="link">
                        <Link to="/faq">FAQs</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/contact-us">Contact Us</Link>
                      </ButtonComponent>
                    </div>
                  </div>
                </Col>
                <Col xs={12} sm={24} md={8} lg={10} xl={8} xxl={8}>
                  <div className="plans">
                    <div className="heading body-b2">Our Offerings</div>
                    <div className="links">
                      <ButtonComponent varient="link">
                        <Link to="/plans?plan=planning_to_apply_abroad">
                          Planning to Apply Abroad
                        </Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/plans?plan=already_applied_abroad">Already Applied Abroad</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/plans?plan=ready_to_fly_abroad">Ready To Fly Abroad</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/plans?plan=already_at_university_abroad">
                          Already at University Abroad
                        </Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/inforens-champions-bundle-pack">Bundle Pack</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/personalised-call">Personalized Call</Link>
                      </ButtonComponent>
                      <ButtonComponent varient="link">
                        <Link to="/mentor-apply">Become a Mentor</Link>
                      </ButtonComponent>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={8} xxl={8} className="application-section">
            <div className="download body-b2">Download Inforens App</div>
            <div className="download-buttons">
              <a
                href="https://play.google.com/store/apps/details?id=com.inforens.app"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/images/googleplayStore.png" alt="Google Play Store" />
              </a>
              <a
                href="https://apps.apple.com/in/app/inforens/id6711349165"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src="/assets/images/appleStore.png" alt="Apple Store" />
              </a>
            </div>
            <div className="connected body-b2">Stay Connected With Us</div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FooterTopbar;
